"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollOptionImage = _interopRequireDefault(require("./PollOptionImage"));

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _helper = require("../common/helper");

var _styles = require("../common/styles");

var _styles2 = require("./styles");

/* eslint-disable indent */
function PollOptions(props) {
  var poll = props.poll,
      dispatch = props.dispatch;
  var options = poll.options;
  var totalResponses = (0, _helper.getTotalResponses)(poll);
  var optionsKeys = Object.keys(options);
  var maxResponses = Math.max.apply(Math, (0, _toConsumableArray2.default)(optionsKeys.map(function (key) {
    return options[key].responses;
  })));
  var multipleMax = optionsKeys.filter(function (key) {
    return options[key].responses === maxResponses;
  }).length > 1;
  return optionsKeys.map(function (key) {
    var option = options[key];
    var imageUrl = option.imageUrl;
    var percentSelected = props.poll.totalVoters > 0 ? Math.round(option.responses / props.poll.totalVoters * 100) : option.responses;
    var isMaximumSelected = maxResponses ? option.responses === maxResponses : false;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(_styles.flexAlignCenterStretch, (0, _styles2.pollOption)(percentSelected, totalResponses, imageUrl), 'option', {
        maximum: isMaximumSelected
      }, {
        multipleMaximum: multipleMax
      }),
      key: key
    }, _react.default.createElement("div", {
      className: "option-bar-wrapper"
    }, _react.default.createElement("div", {
      className: "option-bar"
    }, _react.default.createElement("div", {
      className: "progress"
    }), _react.default.createElement(_DarkText.default, {
      color: isMaximumSelected && !multipleMax ? 'saturn' : 'silver',
      className: "option-text",
      as: "div"
    }, _react.default.createElement(_PollOptionImage.default, {
      poll: poll,
      dispatch: dispatch,
      option: option,
      optionId: key
    }), _react.default.createElement("div", {
      className: "text"
    }, option.text)))), _react.default.createElement(_DarkText.default, {
      color: isMaximumSelected ? 'copper' : 'cobalt',
      className: "option-responses"
    }, percentSelected, " %"));
  });
}

var _default = PollOptions;
exports.default = _default;